import img1 from './assets/01.webp';
import img11 from './assets/1-1.webp';
import img12 from './assets/1-1.webp';
import img2 from './assets/02.webp';
import img22 from './assets/2-1.webp';
import img3 from './assets/03.webp';
import img32 from './assets/3-1.webp';
import img4 from './assets/04.webp';
import img5 from './assets/05.webp';
import img6 from './assets/06.webp';
import img41 from './assets/4-1.webp';
import img51 from './assets/5-1.webp';
import img61 from './assets/6-1.webp';

const standardSlides = [
  {
    id: 'rooms',
    image: img1,
    imageTablet: img11,
    imageMobile: img12,
    name: [
      { text: 'жилые комнаты ', accent: true },
      { text: 'и кухня', accent: false },
    ],
    description: [
      { text: 'идеальная база для вашего интерьера. ', accent: true },
      { text: 'светлые тона визуально расширяют пространство', accent: false },
    ],
    points: [
      {
        id: 'doors',
        x: 12.8,
        y: 53.5,
        xTablet: 25.8,
        yTablet: 75.5,
        tooltip: [
          { text: 'Межквартирные двери ', accent: true },
          { text: 'светлых оттенков', accent: false },
        ],
      },
      {
        id: 'ceiling',
        x: 63.9,
        y: 15.9,
        xTablet: 31.9,
        yTablet: 0.5,
        tooltip: [
          { text: 'Натяжные потолки с закладной ', accent: true },
          { text: 'под потолочную гардину ', accent: false },
        ],
      },
      {
        id: 'ceiling_2',
        x: 40.9,
        y: 10.9,
        xTablet: 30.9,
        yTablet: 52.9,
        tooltip: [
          { text: 'Натяжные потолки с закладной ', accent: true },
          { text: 'под потолочную гардину ', accent: false },
        ],
      },
      {
        id: 'walls',
        x: 68.6,
        y: 49.5,
        xTablet: 35.6,
        yTablet: 15.5,
        tooltip: [{ text: 'Флизелиновые обои фабричного окраса', accent: true }],
      },
      {
        id: 'walls_2',
        x: 30.6,
        y: 49.5,
        xTablet: 55.6,
        yTablet: 69.5,
        tooltip: [{ text: 'Флизелиновые обои фабричного окраса', accent: true }],
      },
      {
        id: 'floor',
        x: 78.4,
        y: 92.8,
        xTablet: 44.4,
        yTablet: 40.8,
        tooltip: [{ text: 'Ламинат 32 класса ', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'floor_2',
        x: 35.4,
        y: 91.8,
        xTablet: 44.4,
        yTablet: 94.8,
        tooltip: [{ text: 'Ламинат 32 класса ', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'baseboard',
        x: 35.4,
        y: 82.8,
        xTablet: 74.4,
        yTablet: 34.8,
        tooltip: [{ text: 'Высокий напольный плинтус  ', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'baseboard_2',
        x: 68.4,
        y: 86.8,
        xTablet: 64.4,
        yTablet: 88.2,
        tooltip: [{ text: 'Высокий напольный плинтус  ', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'chandeliers',
        x: 76,
        y: 26.8,
        xTablet: 54.4,
        yTablet: 2.8,
        tooltip: [{ text: 'Закладные под люстры ', accent: true }],
        tooltipPosition: 'bottom',
      },
      {
        id: 'electrics',
        x: 53.5,
        y: 68.8,
        xTablet: 20.4,
        yTablet: 22.8,
        tooltip: [{ text: 'Полная разводка электрики на кухне ', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'power',
        x: 47.5,
        y: 74.8,
        xTablet: 78.4,
        yTablet: 23.8,
        tooltip: [{ text: 'Выключатели и розетки ', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'power_2',
        x: 88,
        y: 69.8,
        xTablet: 10.4,
        yTablet: 84.8,
        tooltip: [{ text: 'Выключатели и розетки ', accent: true }],
        tooltipPosition: 'right',
      },
    ],
  },
  {
    id: 'bathroom',
    image: img2,
    imageTablet: img22,
    imageMobile: img22,
    name: [
      { text: 'ванные ', accent: true },
      { text: 'комнаты', accent: false },
    ],
    description: [
      { text: 'полностью укомплектованный санузел, ', accent: true },
      { text: 'где сочетаются разные фактуры', accent: false },
    ],
    points: [
      {
        id: 'dalle',
        x: 40.9,
        y: 30.9,
        xTablet: 20.9,
        yTablet: 70.9,
        tooltip: [{ text: 'Керамическая плитка  ', accent: true }],
      },
      {
        id: 'dalle_2',
        x: 55.9,
        y: 30.9,
        xTablet: 70.9,
        yTablet: 15.9,
        tooltip: [{ text: 'Керамическая плитка  ', accent: true }],
      },
      {
        id: 'decorative',
        x: 85.3,
        y: 34.3,
        xTablet: 72.3,
        yTablet: 65.3,
        tooltip: [{ text: 'Декоративная штукатурка  ', accent: true }],
      },
      {
        id: 'floor_3',
        x: 25.2,
        y: 88.7,
        xTablet: 43.2,
        yTablet: 45.7,
        tooltip: [{ text: 'Керамогранит', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'floor_4',
        x: 75.2,
        y: 93.7,
        xTablet: 75.2,
        yTablet: 95.7,
        tooltip: [{ text: 'Керамогранит', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'sanfayance',
        x: 13.6,
        y: 65.8,
        xTablet: 27.6,
        yTablet: 35.8,
        tooltip: [{ text: 'Санфаянс', accent: true }],
      },
      {
        id: 'sanfayance_2',
        x: 23,
        y: 63.8,
        xTablet: 48.6,
        yTablet: 32.8,
        tooltip: [{ text: 'Санфаянс', accent: true }],
      },
      {
        id: 'mixers',
        x: 23,
        y: 56.8,
        xTablet: 48.6,
        yTablet: 29.8,
        tooltip: [{ text: 'Смесители', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'mixers_2',
        x: 33,
        y: 56.8,
        xTablet: 70.6,
        yTablet: 29.8,
        tooltip: [{ text: 'Смесители', accent: true }],
        tooltipPosition: 'bottom',
      },
      {
        id: 'bath',
        x: 40.6,
        y: 75.8,
        xTablet: 69.6,
        yTablet: 42.8,
        tooltip: [{ text: 'Акриловая ванна с экраном', accent: true }],
      },
      {
        id: 'bath_2',
        x: 50.6,
        y: 80.8,
        xTablet: 16.6,
        yTablet: 92.8,
        tooltip: [{ text: 'Акриловая ванна с экраном', accent: true }],
      },
      {
        id: 'heated',
        x: 5.6,
        y: 48.8,
        xTablet: 12.6,
        yTablet: 24.8,
        tooltip: [{ text: 'Электрический полотенцесушитель', accent: true }],
        tooltipPosition: 'right',
      },
      {
        id: 'heated_2',
        x: 91.6,
        y: 48.8,
        xTablet: 86.6,
        yTablet: 75.8,
        tooltip: [{ text: 'Электрический полотенцесушитель', accent: true }],
        tooltipPosition: 'left',
      },
      {
        id: 'lamp',
        x: 31.6,
        y: 5.8,
        xTablet: 49.6,
        yTablet: 1.8,
        tooltip: [{ text: 'Точечные светильники', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'washing',
        x: 9.6,
        y: 72.8,
        xTablet: 20,
        yTablet: 34.8,
        tooltip: [{ text: 'Вывод для стиральной машины', accent: true }],
        tooltipPosition: 'top',
      },
    ],
  },
  {
    id: 'hallway',
    image: img3,
    imageTablet: img32,
    imageMobile: img32,
    name: [
      { text: 'входная ', accent: true },
      { text: 'группа', accent: false },
    ],
    description: [
      { text: 'зона, готовая к уральской погоде и высоким стандартам безопасности ', accent: true },
      { text: 'и высоким стандартам безопасности', accent: false },
    ],
    points: [
      {
        id: 'door',
        x: 28.8,
        y: 41.9,
        xTablet: 53.8,
        yTablet: 21.9,
        tooltip: [{ text: 'Сейф-дверь', accent: true }],
      },
      {
        id: 'smartAccess',
        x: 34.4,
        y: 58.4,
        xTablet: 68.4,
        yTablet: 26.4,
        tooltip: [{ text: 'Умные замки с биометрией  ', accent: true }],
      },
      {
        id: 'zoning',
        x: 87.2,
        y: 93.6,
        xTablet: 49.2,
        yTablet: 40.6,
        tooltip: [{ text: 'Керамогранит в грязной зоне ', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'zoning_2',
        x: 30.2,
        y: 83.6,
        xTablet: 80.2,
        yTablet: 97.6,
        tooltip: [{ text: 'Керамогранит в грязной зоне ', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'connection',
        x: 30.1,
        y: 17.0,
        xTablet: 57.1,
        yTablet: 6.0,
        tooltip: [{ text: 'Розетка для роутера ', accent: true }],
      },
      {
        id: 'connection_2',
        x: 38.1,
        y: 45.0,
        xTablet: 75.1,
        yTablet: 21.0,
        tooltip: [{ text: 'Домофон ', accent: true }],
      },
    ],
  },
];

const comfortSlides = [
  {
    id: 'rooms_2',
    tallTouch: true,
    image: img4,
    imageTablet: img41,
    imageMobile: img41,
    name: [
      { text: 'жилые комнаты ', accent: true },
      { text: 'и кухня', accent: false },
    ],
    description: [
      { text: 'идеальная база для вашего интерьера. ', accent: true },
      { text: 'светлые тона визуально расширяют пространство', accent: false },
    ],
    points: [
      {
        id: 'doors_2',
        x: 10.8,
        y: 43.5,
        xTablet: 22.8,
        yTablet: 18.5,
        tooltip: [
          { text: 'Межквартирные двери ', accent: true },
          { text: 'светлых оттенков', accent: false },
        ],
      },
      {
        id: 'walls_3',
        x: 53.6,
        y: 49.5,
        xTablet: 60.6,
        yTablet: 15.5,
        tooltip: [{ text: 'Флизелиновые обои фабричного окраса', accent: true }],
      },
      {
        id: 'walls_4',
        x: 83.6,
        y: 40.5,
        xTablet: 75.6,
        yTablet: 50.5,
        tooltip: [{ text: 'Флизелиновые обои фабричного окраса', accent: true }],
      },
      {
        id: 'baseboard_3',
        x: 30.4,
        y: 68.8,
        xTablet: 55.4,
        yTablet: 27,
        tooltip: [{ text: 'Высокий напольный плинтус  ', accent: true }],
        tooltipPosition: 'bottom',
      },
      {
        id: 'baseboard_4',
        x: 75.4,
        y: 72.8,
        xTablet: 74.4,
        yTablet: 59.3,
        tooltip: [{ text: 'Высокий напольный плинтус  ', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'ceiling_3',
        x: 50.9,
        y: 10.9,
        xTablet: 25.9,
        yTablet: 2.9,
        tooltip: [
          { text: 'Натяжные потолки с закладной ', accent: true },
          { text: 'под потолочную гардину ', accent: false },
        ],
      },
      {
        id: 'ceiling_4',
        x: 70.9,
        y: 10.9,
        xTablet: 25.9,
        yTablet: 35.9,
        tooltip: [
          { text: 'Натяжные потолки с закладной ', accent: true },
          { text: 'под потолочную гардину ', accent: false },
        ],
      },
      {
        id: 'chandeliers_2',
        x: 40.5,
        y: 18.8,
        xTablet: 47.4,
        yTablet: 1.8,
        tooltip: [{ text: 'Закладные под люстры ', accent: true }],
        tooltipPosition: 'bottom',
      },
      {
        id: 'electrics_2',
        x: 70.5,
        y: 55.8,
        xTablet: 19.4,
        yTablet: 86.8,
        tooltip: [{ text: 'Полная разводка электрики на кухне ', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'power_3',
        x: 27.5,
        y: 59.8,

        xTablet: 15.4,
        yTablet: 56.8,
        tooltip: [{ text: 'Выключатели и розетки ', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'power_4',
        x: 95.5,
        y: 57.8,
        xTablet: 77.4,
        yTablet: 88.8,
        tooltip: [{ text: 'Выключатели и розетки ', accent: true }],
        tooltipPosition: 'left',
      },
      {
        id: 'conditioner',
        x: 54.5,
        y: 26.8,
        xTablet: 83.4,
        yTablet: 42.8,
        tooltip: [{ text: 'Кондиционер ', accent: true }],
        tooltipPosition: 'bottom',
      },
      {
        id: 'lamp_2',
        x: 80.5,
        y: 16.8,
        xTablet: 48.4,
        yTablet: 71.8,
        tooltip: [{ text: 'Точечные светильники в зоне кухни ', accent: true }],
        tooltipPosition: 'bottom',
      },
    ],
  },
  {
    id: 'hallway_2',
    tallTouch: true,
    image: img5,
    imageTablet: img51,
    imageMobile: img51,
    name: [
      { text: 'Ванные ', accent: true },
      { text: 'комнаты', accent: false },
    ],
    description: [
      { text: 'полностью укомплектованный санузел, ', accent: true },
      { text: 'где сочетаются разные фактуры', accent: false },
    ],
    points: [
      {
        id: 'dalle_3',
        x: 40.9,
        y: 30.9,
        xTablet: 16.9,
        yTablet: 50.9,
        tooltip: [{ text: 'Керамическая плитка  ', accent: true }],
      },
      {
        id: 'dalle_4',
        x: 78.9,
        y: 25.9,
        xTablet: 82.9,
        yTablet: 85.9,
        tooltip: [{ text: 'Керамическая плитка  ', accent: true }],
      },
      {
        id: 'floor_5',
        x: 75.2,
        y: 89.7,
        xTablet: 45.2,
        yTablet: 35.7,
        tooltip: [{ text: 'Керамогранит', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'floor_6',
        x: 15.2,
        y: 85.7,
        xTablet: 45.2,
        yTablet: 98.8,
        tooltip: [{ text: 'Керамогранит', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'mixers_3',
        x: 27.5,
        y: 56.8,
        xTablet: 49,
        yTablet: 89,
        tooltip: [{ text: 'Смесители', accent: true }],
        tooltipPosition: 'bottom',
      },
      {
        id: 'mixers_4',
        x: 86.5,
        y: 52.8,
        xTablet: 85.6,
        yTablet: 22.8,
        tooltip: [{ text: 'Смесители', accent: true }],
        tooltipPosition: 'bottom',
      },
      {
        id: 'bath_3',
        x: 40.6,
        y: 75.8,
        xTablet: 20.6,
        yTablet: 62.8,
        tooltip: [{ text: 'Акриловая ванна с экраном', accent: true }],
      },
      {
        id: 'heated_3',
        x: 68.6,
        y: 45.8,
        xTablet: 50.6,
        yTablet: 18.8,
        tooltip: [{ text: 'Электрический полотенцесушитель', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'heated_4',
        x: 12.6,
        y: 45.8,
        xTablet: 85.6,
        yTablet: 53.8,
        tooltip: [{ text: 'Электрический полотенцесушитель', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'drawer',
        x: 86.6,
        y: 65.8,
        xTablet: 80.6,
        yTablet: 30.8,
        tooltip: [{ text: 'Подвесная тумба с интегрированной раковиной', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'drawer_2',
        x: 22.6,
        y: 65.8,
        xTablet: 50.6,
        yTablet: 92.8,
        tooltip: [{ text: 'Подвесная тумба с интегрированной раковиной', accent: true }],
        tooltipPosition: 'bottom',
      },
      {
        id: 'mirror',
        x: 28.6,
        y: 40.8,
        xTablet: 50.6,
        yTablet: 83.8,
        tooltip: [{ text: 'Зеркало с подсветкой', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'mirror_2',
        x: 85.6,
        y: 40.8,
        xTablet: 92.6,
        yTablet: 15.8,
        tooltip: [{ text: 'Зеркало с подсветкой', accent: true }],
        tooltipPosition: 'left',
      },
      {
        id: 'installation',
        x: 77.6,
        y: 52.8,
        xTablet: 25.6,
        yTablet: 89,
        tooltip: [{ text: 'Инсталляция', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'sanfayance_3',
        x: 16,
        y: 73.8,
        xTablet: 64.6,
        yTablet: 28.8,
        tooltip: [{ text: 'Санфаянс', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'sanfayance_4',
        x: 76,
        y: 73.8,
        xTablet: 26.6,
        yTablet: 95.8,
        tooltip: [{ text: 'Санфаянс', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'shower',
        x: 96,
        y: 30.8,
        xTablet: 71.6,
        yTablet: 82,
        tooltip: [{ text: 'Душевая система с тропическим душем', accent: true }],
        tooltipPosition: 'left',
      },
      {
        id: 'lamp_3',
        x: 80.5,
        y: 8.8,
        xTablet: 55.4,
        yTablet: 71.8,
        tooltip: [{ text: 'Точечные светильники ', accent: true }],
        tooltipPosition: 'bottom',
      },
      {
        id: 'washing_2',
        x: 2.6,
        y: 72.8,
        xTablet: 26.6,
        yTablet: 29.8,
        tooltip: [{ text: 'Вывод для стиральной машины', accent: true }],
        tooltipPosition: 'right',
      },
      {
        id: 'communications',
        x: 85.6,
        y: 74.8,
        xTablet: 85.6,
        yTablet: 35.3,
        tooltip: [{ text: 'Коммуникации скрыты', accent: true }],
        tooltipPosition: 'bottom',
      },
    ],
  },
  {
    id: 'hallway_3',
    image: img6,
    imageTablet: img61,
    imageMobile: img61,
    name: [
      { text: 'входная ', accent: true },
      { text: 'группа', accent: false },
    ],
    description: [
      { text: 'зона, готовая к уральской погоде ', accent: true },
      { text: 'и высоким стандартам безопасности', accent: false },
    ],
    points: [
      {
        id: 'door_2',
        x: 28.8,
        y: 41.9,
        xTablet: 53.8,
        yTablet: 21.9,
        tooltip: [{ text: 'Сейф-дверь', accent: true }],
      },
      {
        id: 'smartAccess_2',
        x: 33.4,
        y: 57.4,
        xTablet: 66.8,
        yTablet: 25.9,
        tooltip: [{ text: 'Умные замки с биометрией  ', accent: true }],
      },
      {
        id: 'zoning_3',
        x: 90.2,
        y: 82.6,
        xTablet: 49.2,
        yTablet: 39.6,
        tooltip: [{ text: 'Керамогранит в грязной зоне ', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'zoning_4',
        x: 30.2,
        y: 82.6,
        xTablet: 80.2,
        yTablet: 97.6,
        tooltip: [{ text: 'Керамогранит в грязной зоне ', accent: true }],
        tooltipPosition: 'top',
      },
      {
        id: 'connection_3',
        x: 30.1,
        y: 17.0,
        xTablet: 56.1,
        yTablet: 7.5,
        tooltip: [{ text: 'Розетка для роутера ', accent: true }],
      },
      {
        id: 'connection_4',
        x: 37.1,
        y: 43.0,
        xTablet: 74.1,
        yTablet: 20.5,
        tooltip: [{ text: 'Видеодомофон ', accent: true }],
      },
      {
        id: 'lamp_4',
        x: 67.5,
        y: 10.8,
        xTablet: 75.4,
        yTablet: 51.8,
        tooltip: [{ text: 'Точечные светильники ', accent: true }],
        tooltipPosition: 'bottom',
      },
    ],
  },
];

export const finishingContent = {
  title: [
    { text: '5 видов отделки: ', accent: true },
    { text: '"комфорт" и "стандарт" ', accent: false },
    { text: 'в бежевых и серых тонах ', accent: true },
    { text: 'а также качественная предчистовая', accent: false },
  ],
  slides: {
    standard: standardSlides,
    comfort: comfortSlides,
  },
};
